import request from "@/untils/request.js";
//个人主页
export function getUserInfo() {
  return request({
    url: "/member/user/get",
    method: "get",
  });
}
//修改个人信息
export function editUserInfo(data) {
  return request({
    url: "/member/user/update",
    method: "post",
    data,
  });
}
//用户-获取其它用户基本信息
export function basicInfo(params) {
  return request({
    url: "/member/user/get-info",
    method: "get",
    params,
  });
}
//取消关注
export function cancelFollow(params) {
  return request({
    url: "/member/follow/delete",
    method: "post",
    params,
  });
}
//关注用户
export function addFollow(data) {
  return request({
    url: "/member/follow/add",
    method: "post",
    data,
  });
}
//详情
export function protocolsInfo(params) {
  return request({
    url: "/member/config/terms-info",
    method: "get",
    params,
  });
}

export function getProtocolsList() {
  return request({
    url: "/member/config/terms-list",
    method: "get",
  });
}
